import React, { useEffect, useState } from 'react';
import { Box, Typography, Container, Button } from '@mui/material';
import SEO from '../components/SEO/SEO';
import { useSigilContext } from '../context/sigilContext';
import { useParams, Link } from 'react-router-dom';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';

const Article = () => {
    const { id } = useParams();
    const { i18n } = useSigilContext();
    const [article, setArticle] = useState(null);

    useEffect(() => {
        if (i18n?.grimoire?.articles) {
            const foundArticle = i18n.grimoire.articles.find(a => a.id === id);
            setArticle(foundArticle);
        }
    }, [id, i18n]);

    if (!article) {
        return (
            <Container sx={{ py: 8, textAlign: 'center' }}>
                <Typography variant="h5" color="white">Article not found / Artículo no encontrado</Typography>
                <Button component={Link} to="/grimoire" sx={{ mt: 2 }}>Volver</Button>
            </Container>
        );
    }

    return (
        <>
            <SEO
                title={`${article.title} | Magia del Caos`}
                description={article.content[0].substring(0, 150) + "..."}
                name="Magia del Caos"
                type="article"
            />
            <Container maxWidth="md" sx={{ py: 4, height: 'calc(100vh - 64px)', overflowY: 'auto', pb: 10 }}>
                <Button 
                    startIcon={<ArrowBackIcon />} 
                    component={Link}
                    to="/grimoire"
                    sx={{ color: 'rgba(255,255,255,0.7)', mb: 3 }}
                >
                    Volver al Grimorio
                </Button>

                <Box sx={{ backgroundColor: 'rgba(30, 30, 30, 0.8)', p: { xs: 3, md: 5 }, borderRadius: '16px', border: '1px solid rgba(255,255,255,0.1)' }}>
                    <Typography variant="caption" sx={{ color: 'secondary.main', fontWeight: 'bold', fontSize: '0.9rem' }}>
                        {article.date}
                    </Typography>
                    
                    <Typography variant="h3" component="h1" gutterBottom sx={{ color: 'white', fontWeight: 'bold', mt: 1, mb: 4, lineHeight: 1.2 }}>
                        {article.title}
                    </Typography>

                    <Box sx={{ 
                        color: 'rgba(255,255,255,0.85)', 
                        fontSize: '1.1rem', 
                        lineHeight: 1.8,
                        '& p': { marginBottom: '1.5em' },
                        '& strong': { color: 'primary.main' }
                    }}>
                        {article.content.map((paragraph, index) => (
                            <Typography key={index} variant="body1" paragraph dangerouslySetInnerHTML={{ __html: paragraph.replace(/\*\*(.*?)\*\*/g, '<strong>$1</strong>') }} />
                        ))}
                    </Box>
                </Box>
            </Container>
        </>
    );
};

export default Article;
